export class Addon {
  public Type: string;
  public BaseUrl: string;
  public OrganziationId?: any;
  public Domain?: string;
  public HomeTopicId?: string;
  public AccessToken?: string;
  public Id?: string
  public technadoptAuthData?: any;
  public customTabData?: CustomTabData
  public espClaimOwnershipData?: EspClaimOwnership
  public PublicProperties?: PublicProperties
  public Configuration?: Configuration
  public InstanceId?: string
  public EntityType?: string
  public TeamIds?: Array<any>
}

export class TechnadoptAuthData {
  accessToken: string
  expiresIn: number
  roles: string[]
}

export interface EspClaimOwnership {
  url: string;
  name: string;
  id: number;
  filedId: string;
}

export class CustomTabData {
  name?: string
  productId?: string
  icon?: number
  viewOn?: string
  subtype?: any
  customTabId?: string
}

export interface PublicProperties {
  access_token?: string
  baseURL?: string
  domain?: string
  groupIdenedi: string
  homeTopicId?: string
  icon?: number
  jsonData?: any
  name?: string
  organizationName?: string
  organziationId?: string
  powerBiData?: any
  productId?: string
  productName?: string
  refresh_token?: string
  subtype?: number
  title?: string
  viewOn?: string,
  sortedTabs?: any,
  tabOrder?: any[]
  customTabId?: string
  language?:string
  logoUrl?:string
  footerDescription?: string,
  footerTitle?: string,
  subgroupsAccessList?: { [key: string]: string; }[];
}

export interface Configuration {
  domain?: string,
  userId?: string,
  organziationId?: string,
  espTokenId?: number,
  baseURL?: string,
  access_token?: string,
  refresh_token?: string
}

export class PowerBiData {
  displayName: string
  webUrl: string
  id: string
  isReadOnly: boolean
  groupId: string
  embedUrl: string
}


export class JsonData {
  constructor(public data: {
    iseditable: number
    isvisible: number
    key: string
    name: string
    order: number
  }[]) {
  }
}
